export default __webpack_public_path__ + "static/media/contactsOrange.75754594.svg";